<!--
  线下充值状态
  lovi 2020-1-10
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="data.title"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    />

    <div class="scroll-wrapper">
      <scroll>
        <div class="status-wrap">
          <img src="@/assets/images/public/icon_success@2x.png" />
          <h3>{{ $t("wallet.successfullySubmitted") }}</h3>
        </div>

        <van-cell-group>
          <van-cell :title="$t('wallet.rechargeType')" :value="data.title" />
          <van-cell :title="$t('wallet.rechargeAmount')">
            <div slot="default">
              {{ data.money }}
              <template
                v-if="
                  data.type == 8 &&
                    (data.bank.country == 1 || data.bank.country == 3)
                "
              >
                / {{ data.exchange }}
                {{
                  data.bank.country == 1
                    ? "RMB"
                    : data.bank.country == 3
                    ? "VND"
                    : ""
                }}
              </template>
            </div>
          </van-cell>
          <van-cell :value="data.additional_code">
            <div slot="title">
              <span>{{ $t("wallet.additionalCode") }}</span>
              <i
                class="icon-copy"
                :data-clipboard-text="data.additional_code"
                @click="copyText"
              ></i>
            </div>
          </van-cell>
          <template v-if="data.type == 8">
            <van-cell :value="data.bank.bank_name">
              <div slot="title">
                <span>{{ $t("wallet.openingBank") }}</span>
                <i
                  class="icon-copy"
                  :data-clipboard-text="data.bank.bank_name"
                  @click="copyText"
                ></i>
              </div>
            </van-cell>
            <van-cell :value="data.bank.bank_username">
              <div slot="title">
                <span>{{ $t("wallet.accountNumber") }}</span>
                <i
                  class="icon-copy"
                  :data-clipboard-text="data.bank.bank_username"
                  @click="copyText"
                ></i>
              </div>
            </van-cell>
            <van-cell :value="data.bank.card_number">
              <div slot="title">
                <span>{{ $t("wallet.bankCardNumber") }}</span>
                <i
                  class="icon-copy"
                  :data-clipboard-text="data.bank.card_number"
                  @click="copyText"
                ></i>
              </div>
            </van-cell>
          </template>
        </van-cell-group>
        <div class="button-wrap">
          <van-button block type="primary" @click="_back">
            {{ $t("common.done") }}
          </van-button>
          <p class="tips">
            {{ $t("wallet.topUpTips") }}
          </p>
        </div>
      </scroll>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
export default {
  props: ["data"],
  components: {},
  data() {
    return {};
  },
  created() {
    console.log("data", this.data);
  },
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 返回事件
      this.$emit("update:statusFlag", false);
    },
    copyText() {
      var clipboard = new Clipboard(".icon-copy");
      clipboard.on("success", e => {
        console.info("Action:", e.action);
        this.$toast(this.$t("common.copySuccess"));
        clipboard.destroy(); // 释放内存
      });
      clipboard.on("error", e => {
        console.info("error:", e.action);
        this.$toast(this.$t("common.browserNoCopy"));
        clipboard.destroy(); // 释放内存
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.status-wrap {
  padding: 20px 0;
  text-align: center;
  img {
    width: 64px;
  }
  h3 {
    margin-top: 10px;
    font-size: 24px;
    font-weight: 500;
  }
}

/deep/.van-cell {
  .van-cell__title {
    flex: initial;
    margin-right: 10px;
    div {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .icon-copy {
        margin-left: 10px;
        width: 10px;
        height: 12px;
        background: url("~@/assets/images/public/icon_copy@2x.png") no-repeat;
        background-size: 100%;
      }
    }
  }
}
</style>
